import { LoadingPage } from "@/components/elements/Loading/Loading";
import { JobForm } from "@/features/job/components/JobForm";
import { DEFAULT_ONBOARDING_SUPPORTS, DEFAULT_SELF_EXPENSES } from "@/features/job/constants/defaults";
import { TJobForm } from "@/features/job/types/JobForm";
import { createJobSalarySummaryForm, initJobWorkingTimeForm } from "@/features/job/utils/convertJobFormData";
import { YES_NO_PENDING_STATUS } from "@/types/enum";
import { showError } from "@/utils/error";
import dayjs from "dayjs";
import { useEffect, useState } from "react";

export const JobCreatePage = () => {
  const [defaultValues, setDefaultValues] = useState<Partial<TJobForm> | undefined>(undefined);

  useEffect(() => {
    const key = "duplicated-job-data";
    const jobData = localStorage.getItem(key);
    if (jobData) {
      try {
        const parsedData = JSON.parse(jobData) as Partial<TJobForm>;
        // Dayjs instances get serialized to plain strings via JSON.stringify — rehydrate them
        // back to Dayjs so MUI date pickers can call .isValid() / .toISOString() etc.
        if (parsedData.startDate) parsedData.startDate = dayjs(parsedData.startDate as unknown as string);
        if (parsedData.endDate) parsedData.endDate = dayjs(parsedData.endDate as unknown as string);
        setDefaultValues(parsedData);
        // Remove it after loading to avoid reusing it.
        localStorage.removeItem(key);
      } catch (e) {
        showError(e);
      }
    } else {
      setDefaultValues({});
    }
  }, []);

  if (!defaultValues) return <LoadingPage />;

  const initDefaultValues = {
    ...defaultValues,
    jobWorkingTimes: defaultValues?.jobWorkingTimes ?? [initJobWorkingTimeForm],
    jobSalarySummaries: defaultValues?.jobSalarySummaries ?? [createJobSalarySummaryForm()],
    bonus: defaultValues?.bonus ?? YES_NO_PENDING_STATUS.PENDING,
    salaryRaise: defaultValues?.salaryRaise ?? YES_NO_PENDING_STATUS.PENDING,
    selfExpense: defaultValues?.selfExpense ?? DEFAULT_SELF_EXPENSES,
    onboardingSupport: defaultValues?.onboardingSupport ?? DEFAULT_ONBOARDING_SUPPORTS,
    matchOfficeId: defaultValues?.matchOfficeId,
  };

  return <JobForm defaultValues={initDefaultValues} />;
};
